export default (() => {
  console.log(111);
});

